import {observable, action} from 'mobx';
import {makeAutoObservable} from 'mobx';

class UserInfoStore {
    constructor() {
        makeAutoObservable(this);
    }

    @observable value = '';

    @action updateValue(newValue: string) {
        this.value = newValue;
    }

    @action resetValue() {
        this.value = '';
    }
}

export default new UserInfoStore();